import React, { forwardRef } from "react";
import googleConfig from "./google-config";
import styled from "styled-components";
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import IBuildrProps from "../../utilities/IBuildrProps";
import useLanguage from "../../utilities/useLanguage";
import Markers from "./Markers";
import ConditionalWrapper from "../ConditionalWrapper";

export interface IMapProps extends IBuildrProps {
    children: any;
    latitude: number;
    longitude: number;
    loadMap?: boolean;
    mapContainerStyle?: any;
    maxZoom?: number;
    panTo: { lat: number; lng: number };
    zoom: number | string;
    excludeApi?: boolean;
}

const MapContainer = styled.div`
    @media (min-width:992px) {
        height: 530px;
    }

    @media (max-width:991px) {
        height: 40vh;
    }
`;

export default forwardRef(({ children, zoom = 12, latitude, longitude, panTo, mapContainerStyle, loadMap = true, maxZoom = 20, excludeApi }: IMapProps, ref: any) => {
    const { lang } = useLanguage();
    if (loadMap) {
        return (
            <ConditionalWrapper
                condition={!excludeApi}
                wrapper={children => <APIProvider apiKey={googleConfig.apiKey} language={lang} libraries={googleConfig.libraries}>{children}</APIProvider>}>
                <MapContainer>
                    <Map
                        style={mapContainerStyle}
                        id="macuComMap"
                        mapId="36eb04c88fbfbc43"
                        defaultCenter={{ lat: Number(latitude), lng: Number(longitude) }}
                        defaultZoom={Number(zoom)}
                        minZoom={4}
                        maxZoom={Number(maxZoom)}>
                        <Markers panTo={panTo}>
                            {children}
                        </Markers>
                    </Map>
                </MapContainer>
            </ConditionalWrapper>
        );
    } else {
        return (
            <div className="bg-gray-200 p-4" style={{minHeight: '500px', ...mapContainerStyle}}>Map is not enabled</div>
        );
    }
});